class VwRezervbarkod1DTO {
    pkRezervbarkod1: number = 0;
    fkOrganizasyon?: number = null;
    aciklama?: string = "";
    barkodsayi?: number = null;
    barkodboyut?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    iptal?: string = "H";
    iptalBool?: boolean = false;
    fkIptalneden?: number = null;
    iptaltarih?: string = null;
    fkIptalkullanici?: number = null;
    organizasyonAdi?: string = "";
    ekleyenKullaniciAdi?: string = "";
    iptalKullaniciAdi?: string = "";
    barkodbilgisi?: string = "";
    fkKurum?: number = null;
    kurumAdi?: string = "";
    yazdirildi?: string = "H";
};
export default VwRezervbarkod1DTO;